module.exports = function() {
  return new Worker(__webpack_public_path__ + "c36a4f116d05022fed08.worker.js");
};